import { useLazyQuery, useQuery } from "@apollo/client";
import { USER_CUSTOMERS } from "../user-customer.queries";
import {
  UserCustomersQuery,
  UserCustomersQueryVariables,
} from "../../../__generated__/UserCustomersQuery";

export const useUserCustomers = (variables: UserCustomersQueryVariables) => {
  return useQuery<UserCustomersQuery, UserCustomersQueryVariables>(USER_CUSTOMERS, {
    variables,
  });
};

export const useLazyUserCustomers = () => {
  return useLazyQuery<UserCustomersQuery, UserCustomersQueryVariables>(
    USER_CUSTOMERS
  );
};
